import React from "react";
import "../styles/Services.css";
import acbImg from '../assets/images/acb.jpg';
import vcbImg from '../assets/images/vcb.jpg';
import mccbImg from '../assets/images/mccb.jpg';
import retrofitImg from '../assets/images/retrofitting.jpg';
import ctptImg from '../assets/images/ctpt.jpg';
import switchgearImg from '../assets/images/switchgears.jpg';
import panelsImg from '../assets/images/LTHTPanels.jpg';
import relayImg from '../assets/images/LTHTProtectionRelay.jpg';
import transformerImg from '../assets/images/transformer.jpg';

const services = [
  {
    title: "Air Circuit Breaker (ACB)",
    img:acbImg ,
    description: "Ensure reliable electrical protection with our ACB solutions, including sales, servicing, and testing, backed by expert technicians and quality spare parts."
  },
  {
    title: "Vacuum Circuit Breaker (VCB)",
    img: vcbImg,
    description: "Opt for our VCB services for efficient 11KV and 33KV solutions. We offer comprehensive maintenance, inspection, and replacement of defective parts, ensuring uninterrupted power distribution."
  },
  {
    title: "Molded Case Circuit Breaker (MCCB)",
    img: mccbImg,
    description: "Trust our MCCB expertise for robust circuit protection in various applications. We provide sales, servicing, and replacement of MCCBs, ensuring safety and reliability."
  },
  {
    title: "Retrofitting",
    img: retrofitImg,
    description: "Upgrade your electrical systems with our retrofitting service. Enhance efficiency, safety, and performance without the hassle of full replacements. Trust our expertise for seamless upgrades."
  },
    {
    title: "CT & PT",
    img: ctptImg,
    description: "Our CT & PT services guarantee accurate current and voltage measurement. We offer installation, testing, and calibration to ensure precise readings and optimal system performance."
  }
,
{
  title: "Switchgears & SPares",
  img:switchgearImg,
  description:"Choose from a wide range of switchgears and quality spare parts to meet your electrical needs. Our offerings include sales, servicing, and replacement, ensuring dependable operation."
},
{
  title:"LT/HT Electrical Panels",
  img:panelsImg,
  description: "Get custom-designed LT/HT electrical panels for efficient power distribution. Our services include panel installation, testing, and maintenance to ensure safety and reliability."
},
{title:"LT/HT Protection Relay",
  img:relayImg,
  description:"Enhance electrical system protection with our LT/HT protection relay solutions. We offer sales, installation, and calibration services to safeguard your equipment and personnel."
},
{
  title:"Transformer",
  img:transformerImg,
  description:"Experience top-notch transformer services with GratitudeTech. From repairing and testing to oil filtration, we ensure optimal performance and longevity for your transformers. Trust our expertise."
}
];

function Services() {
  return (
    <div className="services-section">
      <h2 className="services-title">Our Services</h2>
      <p>At AGR Consultant & Engineers, we offer a comprehensive range of services designed to meet all your electrical needs.</p>
      <div className="services-cards">
        {services.map((service, idx) => (
          <div className="service-card" key={idx}>
            <img src={service.img} alt={service.title} className="service-image" />
            <h3 className="service-title">{service.title}</h3>
            <p className="service-desc">{service.description}</p>
          </div>
        ))}
      </div>
      </div>
  );
}

export default Services;
